/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Between 40 and 50: (|40 − 50| ÷ 45) × 100 ≈ 22.22%.`)
};

const es_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 40 y 50: (|40 − 50| ÷ 45) × 100 ≈ 22,22%.`)
};

const de_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischen 40 und 50: (|40 − 50| ÷ 45) × 100 ≈ 22,22 %.`)
};

const nl_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tussen 40 en 50: (|40 − 50| ÷ 45) × 100 ≈ 22,22%.`)
};

const fr_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 40 et 50 : (|40 − 50| ÷ 45) × 100 ≈ 22,22 %.`)
};

const it_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tra 40 e 50: (|40 − 50| ÷ 45) × 100 ≈ 22.22%.`)
};

const pt_br2_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 40 e 50: (|40 − 50| ÷ 45) × 100 ≈ 22,22%.`)
};

const pt_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 40 e 50: (|40 − 50| ÷ 45) × 100 ≈ 22.22%.`)
};

const ja_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40と50の間: (|40 − 50| ÷ 45) × 100 ≈ 22.22%。`)
};

const zh_pct_difference_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40 和 50 之间：(|40 − 50| ÷ 45) × 100 ≈ 22.22%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_ex2", locale)
	if (locale === "en") return en_pct_difference_ex2(inputs)
	if (locale === "es") return es_pct_difference_ex2(inputs)
	if (locale === "de") return de_pct_difference_ex2(inputs)
	if (locale === "nl") return nl_pct_difference_ex2(inputs)
	if (locale === "fr") return fr_pct_difference_ex2(inputs)
	if (locale === "it") return it_pct_difference_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_ex2(inputs)
	if (locale === "pt") return pt_pct_difference_ex2(inputs)
	if (locale === "ja") return ja_pct_difference_ex2(inputs)
	return zh_pct_difference_ex2(inputs)
};